'use client';

import { usePeriod } from '@/app/context/PeriodContext';
import {
  useFindAllCollaboratorProjectQuery,
  useFindAllDebitProjectAndExpenseQuery,
  useFindAllGroupedByDebitProjectQuery,
} from '@/app/services/SharingDetails';
import SharingCollaboratorTable from '@/components/sharingDetails/SharingCollaboratorTable';
import SharingTableHeader from '@/components/sharingDetails/SharingTableHeader';
import SharingTableHeaderDetail from '@/components/sharingDetails/SharingTableHeaderDetail';
import { Box } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

function SharingDetails() {
  const { code } = useParams();

  const { selectedPeriod } = usePeriod();
  const { t } = useTranslation('sharingDetails');

  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);

  const { data: sharingDetailsDebitProject } = useFindAllGroupedByDebitProjectQuery(
    {
      data: selectedPeriod?.date as string,
      searchTerm: code || '',
      page,
      size,
    },
    {
      skip: !selectedPeriod?.date,
    },
  );

  const { data: sharingDetailsDebitProjectAndExpense } = useFindAllDebitProjectAndExpenseQuery(
    {
      data: selectedPeriod?.date as string,
      searchTerm: code || '',
      page,
      size,
    },
    {
      skip: !selectedPeriod?.date,
    },
  );

  const { data: sharingCollaboratorProject } = useFindAllCollaboratorProjectQuery(
    {
      data: selectedPeriod?.date as string,
      searchTerm: code || '',
    },
    {
      skip: !selectedPeriod?.date,
    },
  );

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        mr: 2,
      }}
    >
      <Box
        sx={{
          mb: 4,
          mt: 1,
        }}
      >
        <SharingTableHeader rows={sharingDetailsDebitProject?.content || []} />
        <SharingTableHeaderDetail rows={sharingDetailsDebitProjectAndExpense?.content || []} />
      </Box>

      <SharingCollaboratorTable rows={sharingCollaboratorProject || []} />
    </Box>
  );
}

export default SharingDetails;
